export const DirekteinnsynJSProject = 'HN.Direkteinnsyn.JS';
export const RegisterinnsynJSProject = 'HN.Registerinnsyn.JS';
export const ForskningJSProject = 'HN.Forskning.JS';
export const HelseregistreJSProject = 'HN.Helseregistre.JS';
export const TestRegisterinnsynProject = 'HN.TestRegisterinnsyn.JS';
